import type { RouteRecordRaw } from 'vue-router';
import { PermissionAction, PermissionResource } from '@nailsupply/review-swagger/auth';
import { allServiceRoutes } from '@/pages/service/routes';

export const serviceRoutes: RouteRecordRaw = {
  path: '',
  component: () => import('@/layouts/main.vue'),
  meta: {
    requireAuth: true,
    requireStoreId: true,
    permission: { resource: PermissionResource.enum.default_service, action: PermissionAction.enum.view },
  },
  children: [
    ...allServiceRoutes,
  ],
};
